import React from "react";
import { Modal, ProgressBar } from "react-bootstrap";
import { log_error } from "../../../api";
import _ from "lodash";
import { object_url, getCurrentUser } from "../../../api/helper";
import { uploadMedia } from "../../../api/aws_s3";
import { isWithinImageSizeLimit, IMAGE_SIZE_LIMIT } from "../viewsHelper";
import "./styles.scss";
import chooseFile from "../../../public/images/chooseFile.png";

export default class ImageUploader extends React.Component {
  state = {
    show: false,
    s3_object_key: null,
    progress: null,
    error: null,
  };
  handleClick = (e) => this.hocWrapper.current.contains(e.target) && this.handleShow();
  componentDidMount = () => document.body.addEventListener("click", this.handleClick);
  componentWillUnmount = () => document.body.removeEventListener("click", this.handleClick);
  handleClose = () => this.setState({ show: false });
  handleShow = () => this.setState({ show: true });
  uploadImage = async () => {
    try {
      if (!this.fileInput.current.files[0]) {
        this.setState({ error: "Select a file" });
        return;
      }
      if (!isWithinImageSizeLimit(this.fileInput.current.files.item(0))) {
        this.setState({ error: `Oops! The maximum filesize is ${IMAGE_SIZE_LIMIT / 1024}MB. Try to upload a smaller image, or use a tool like ` });
        return;
      }
      let s3_object_key = object_url();
      await uploadMedia(this.fileInput.current.files[0], this.fileInput.current.files[0].type, getCurrentUser().id, s3_object_key, (e) => {
        this.setState({
          progress: (e.loaded * 100) / e.total,
        });
      });
      this.props.onSubmit(s3_object_key, this.fileInput.current.files[0]);
      this.handleClose();
    } catch (error) {
      console.log(log_error(error));
    } finally {
      this.setState({ progress: null });
    }
  };
  fileInput = React.createRef();
  hocWrapper = React.createRef();
  render() {
    const { title, subtitle } = this.props;
    return (
      <div>
        <div ref={this.hocWrapper} className={"hor_click " + this.props.className}>
          {this.props.children}
        </div>
        <Modal id={this.props.id} show={this.state.show} onHide={this.handleClose} className="modal-image-uploader">
          <Modal.Body>
            <Modal.Title>{title || "Upload a Profile Picture"}</Modal.Title>
            {subtitle && <p className="subtitle">{subtitle}</p>}
            <div className="row">
              <div className="col-100">
                <div className="form-group mb-0">
                  <label htmlFor="fileInput">
                    {this.state.error && (
                      <span className="text-danger">
                        {" "}
                        {this.state.error}
                        <a href="https://imagify.io/optimizer/" target="_blank">
                          Imagify
                        </a>
                        &nbsp;to easily compress your file.
                      </span>
                    )}
                  </label>
                  <div className="attachment-upload text-center">
                    <label htmlFor="file-input">
                      <img src={chooseFile} />
                    </label>
                    <input
                      id="file-input"
                      type="file"
                      className="form-control-file"
                      onChange={this.uploadImage}
                      ref={this.fileInput}
                      onClick={() => {
                        this.setState({ error: null });
                      }}
                    />
                  </div>
                </div>
                {!_.isNull(this.state.progress) && <ProgressBar now={this.state.progress} />}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
